import { Button, mergeClasses } from '@fluentui/react-components';
import { useNovaEventing } from '@nova/react';
import { AppBarEvents } from '@office-start/appbar-events';
import AppBarIcons from '@office-start/appbar-icons';
import React from 'react';
import { useFlyoutLinkStyles } from './FlyoutFooterLink.styles';
/**
 * A link that is to be rendered in the footer of the flyout.
 */
export var FlyoutFooterLink = function (_a) {
    var _b;
    var showButtonView = _a.showButtonView, footerLink = _a.footerLink, linkFormat = _a.linkFormat, linkedEntity = _a.linkedEntity, onClicked = _a.onClicked;
    var styles = useFlyoutLinkStyles();
    var IconComponent = null;
    var novaEventing = useNovaEventing();
    var useFooterLinkCallback = React.useCallback(function (reactEvent) {
        if (footerLink) {
            novaEventing.bubble({
                event: AppBarEvents.appAcquisitionLinkClick(function () {
                    return {
                        linkID: footerLink.id,
                        context: linkedEntity,
                    };
                }),
                reactEvent: reactEvent,
            });
        }
        if (onClicked) {
            onClicked();
        }
        if (reactEvent) {
            reactEvent.stopPropagation();
        }
    }, [novaEventing, footerLink, linkedEntity, onClicked]);
    if ((_b = footerLink === null || footerLink === void 0 ? void 0 : footerLink.icon) === null || _b === void 0 ? void 0 : _b.name) {
        IconComponent = AppBarIcons[footerLink.icon.name];
    }
    // If the link format is icon - text, then reverse the default behavior (which is text - icon)
    var reverseContent = linkFormat === 'IconText';
    var footerLinkRootStyles = React.useMemo(function () {
        return mergeClasses(showButtonView
            ? styles.appAcquisitionLink
            : styles.appAcquisitionLinkButton);
    }, [styles, showButtonView]);
    var footerLinkContainerStyles = React.useMemo(function () {
        return mergeClasses(styles.appAcquisitionLinkContainer, reverseContent && styles.appAcquisitionLinkContainerReversed);
    }, [styles, reverseContent]);
    var footerLinkLabelStyles = React.useMemo(function () {
        return mergeClasses(styles.appAcquisitionLinkLabel, reverseContent && styles.appAcquisitionLinkLabelReversed);
    }, [styles, reverseContent]);
    var footerLinkIconStyles = React.useMemo(function () {
        return mergeClasses(styles.appAcquisitionLinkIcon, reverseContent && styles.appAcquisitionLinkIconReversed);
    }, [styles, reverseContent]);
    return (footerLink && (React.createElement(Button, { className: footerLinkRootStyles, onClick: useFooterLinkCallback },
        React.createElement("span", { className: styles.appAcquisitionLinkContent },
            React.createElement("span", { className: footerLinkContainerStyles },
                React.createElement("span", { className: footerLinkLabelStyles }, footerLink.text),
                React.createElement("span", { className: footerLinkIconStyles }, IconComponent && React.createElement(IconComponent, null)))))));
};
//# sourceMappingURL=FlyoutFooterLink.js.map